import * as React from 'react';
import './styles/common.less';
import './styles/analyzed-doc.less';
import './styles/sessions.less';
import 'react-quill/dist/quill.snow.css';
import './styles/new-contract-analysis.less';
import { configure } from 'mobx';
import { bootstrap } from './modules/common';
import { AskAlphaStoresConditionalProvider } from './modules/ask_alpha/stores/context';
import { BrowserRouter } from 'react-router-dom';
import MainLayout from './modules/UI/components/MainLayout';
import 'ant-design-draggable-modal/dist/index.css';
import { DraggableModalProvider } from 'ant-design-draggable-modal';
import * as Sentry from '@sentry/react';

configure({ enforceActions: 'observed' });

// function init() {

//   // TODO: find a better way to to keep store's state when doing hot reload
//   if (process.env.NODE_ENV === 'development') {
//     // eslint-disable-next-line @typescript-eslint/no-explicit-any
//     // (window as any).stores = (window as any).stores || rootStores;
//   }
// }

let sentryConfig = require('./sentry.json') as Record<string, string>;

if (window.RUNTIME_CONFIG?.sentryConfig) {
    sentryConfig = {
        ...sentryConfig,
        ...(window.RUNTIME_CONFIG.sentryConfig as Record<string, string>)
    };
}

if (sentryConfig.dsn && sentryConfig.dsn !== '') {
    Sentry.init({
        dsn: sentryConfig.dsn,
        environment: sentryConfig.environment
    });
}

class App extends React.Component {
    componentDidMount() {
        if (process.env.REACT_APP_DISABLE_ANIMATIONS === 'true') {
            document.body.className = 'no-anims';
        }
    }

    render() {
        console.log(`Version: ${process.env.REACT_APP_VERSION}`);

        return (
            <Sentry.ErrorBoundary>
                <DraggableModalProvider>
                    <bootstrap.StoreProvider>
                        {/* Ask alpha state should not be reset when navigating between pages, that's why we provide stores on top level */}
                        <AskAlphaStoresConditionalProvider>
                            <BrowserRouter>
                                <MainLayout />
                            </BrowserRouter>
                        </AskAlphaStoresConditionalProvider>
                    </bootstrap.StoreProvider>
                </DraggableModalProvider>
            </Sentry.ErrorBoundary>
        );
    }
}

export default App;
